
import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import CookieConsent from "./components/feature/CookieConsent";

function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <AppRoutes />
      <CookieConsent />
    </BrowserRouter>
  );
}

export default App;
